<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>


      <el-row>
        <el-col :span="24">
          <el-card>
            <h3>返利设置</h3>
            <el-form :model="form" label-width="120px">

            <!-- 结算日期选择 -->
      <el-form-item label="结算日期">
        <el-radio-group v-model="form.settlementDateType">
          <el-radio :label="'first'">每月第一天</el-radio>
          <el-radio :label="'middle'">每月月中</el-radio>
          <el-radio :label="'end'">每月月末</el-radio>
        </el-radio-group>
      </el-form-item>
                      

              <el-form-item label="新客户返利">
                <el-input v-model="form.newCustomerRebate" style="width: 100px;" placeholder="请输入新客户返利"></el-input>%
              </el-form-item>

              <el-form-item label="老客户返利">
          
                <el-input v-model="form.oldCustomerRebate" style="width: 100px;" placeholder="请输入老客户返利"></el-input>%
              </el-form-item>

              <el-form-item label="返利调整周期">
                <el-input v-model="form.rebateCycle" style="width: 100px;" placeholder="请输入周期，单位月"></el-input>月
              </el-form-item>

              <!-- <el-form-item label="业务员ID">
                <el-input v-model="form.user_id" placeholder="请输入业务员ID"></el-input>
              </el-form-item> -->
            </el-form>
          </el-card>
        </el-col>
      </el-row>

      <!-- <el-form-item label="结算方式" prop="limit_type" >
        <el-radio-group v-model="form.limit_type">
              <el-radio label="month">按月结算</el-radio>
              <el-radio label="twomonth">按年结算</el-radio>
        </el-radio-group>
        <div>结算后的数据不参与下一次结算</div>
      </el-form-item>


      <el-form-item label="每个门店下单次数" prop="num">
        <el-input style="width: 150px;" type="number" v-model="form.num"  placeholder="请输入下单次数"></el-input>

      </el-form-item>

      <el-form-item label="每个门店进货金额" prop="num">
        <el-input style="width: 150px;" type="number" v-model="form.price"  placeholder="请输入每个门店进货金额"></el-input>

      </el-form-item>



      <el-form-item label="返佣方式" prop="ftype" >
        <el-radio-group v-model="form.ftype">
              <el-radio :label="1">固定</el-radio>
              <el-radio :label="2">比例</el-radio>
        </el-radio-group>

      </el-form-item>


      <el-form-item label="返佣数值" prop="amount">
        <el-input style="width: 150px;" type="number" v-model="form.amount"  placeholder="请输入返佣数值"></el-input>
        <span v-if="form.type == 1">元</span>
        <span v-if="form.type == 2">%</span>
      </el-form-item> -->



    </el-form>

    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>

      <!-- <el-button size="small" type="primary" @click="jsr" :disabled="loading">计算</el-button> -->
    </div>

    <!--商品图片组件-->
    <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload> -->
  </div>
</template>
<script>
import SalerApi from '@/api/saler.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      form: {
        status: false,
        num:0,
        price:0,
        // recomm_store:[{
        //   "num":0,
        //   "price":0
        // }],
        // order_num:[{
        //   "num":0,
        //   "price":0
        // }]
        ftype:1,
        amount:0,

        settlementDate:'end',
        baseRebateRate: 5,
        newCustomerRebate: 5,
        oldCustomerRebate: 1,
        rebateCycle: 12,
        user_id:'',

      },
      setting: [],
      loading: false,
      isProductUpload:false,
  
    };
  },
  created() {

    this.getSetting();
  },
  methods: {
   
    addOrderNum(){
      this.form.order_num.push({
          "num":0,
          "price":0
        });
    },
    delOrderNum(index){
        this.form.order_num.splice(index,1)
    },


    addRecommStore(){
      this.form.recomm_store.push({
          "num":0,
          "price":0
        });
    },
    delRecommStore(index){
        this.form.recomm_store.splice(index,1)
    },

    
    
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      SalerApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.form = data.data.vars.values;
          }
          if(!data.data.vars.values.recomm_store){
            self.form.recomm_store = [];
          }
          if(!data.data.vars.values.order_num){
            self.form.order_num = [];
          }
     
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      SalerApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    jsr(){
      let self = this;
      let params = self.form;
      SalerApi.calculateRebate(params, true)
        .then(data => {
          console.log('data',data.data)
        })
        .catch(error => {
          self.loading = false;
        });
      
    }

  }
};
</script>

<style>
.el-card {
  padding: 20px;
  margin-top: 20px;
}
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/saler/setting/getSetting.vue